import { Hypertext, Icon, IconName, IconSize, IconVariant, Popover } from "@quortex/front-common"
import type { FC } from "react"
import { useWorkspacePath } from "@/hooks/navigation"

interface SegmentListCellProps {
  segmentList?: api.switchns.CdnSegment[]
}

const SegmentListCell: FC<SegmentListCellProps> = ({ segmentList }) => {
  const workspacePath = useWorkspacePath()

  return (
    <Popover
      body={
        <div className="flex flex-col gap-xs">
          {segmentList?.map(segment => (
            <Hypertext
              key={segment.uuid}
              data-testid={`segment-list-link-${segment.uuid}`}
              to={`${workspacePath}/segmentation/segment/${segment.uuid}`}
              onClick={e => {
                e.stopPropagation()
              }}
            >
              <Icon
                className="mr-xs text-blue-500"
                icon={IconName.GLOBE}
                size={IconSize.MEDIUM}
                type={IconVariant.SOLID}
              />
              {segment.name}
            </Hypertext>
          ))}
        </div>
      }
      description="string"
      enabled={segmentList && segmentList.length > 0}
      hoverProps={{
        delay: { close: 200, open: 300 }
      }}
      placement="right"
      showTransitions
      trigger="hover"
    >
      {`${segmentList?.length} segment${segmentList && segmentList.length > 1 ? "s" : ""}`}
    </Popover>
  )
}

export default SegmentListCell
